import React, { Component } from 'react';
import { TabBar } from 'antd-mobile';
import AgentMine from './AgentMine';
import Constants from '../utils/Constants';
import StorageUtils from '../utils/StorageUtils';
import iconOrder from '../medias/icon-order.svg';
import iconOrderSelected from '../medias/icon-order-selected.svg';
import iconHome from '../medias/icon-home.svg';
import iconHomeSelected from '../medias/icon-home-selected.svg';
import iconMine from '../medias/icon-mine.svg';
import iconMineSelected from '../medias/icon-mine-selected.svg';
import DataFetcher from '../utils/DataFetcher';
import OrderOfAgent from './OrderOfAgent';
import HomeOfAgent from './HomeOfAgent';

const history = require("history").createHashHistory()

class Agent extends Component {
    constructor(props){
        super(props);

        let selectedTab = StorageUtils.retrieveStringFromSession(Constants.Storage.HOME_SELECTED_TAB);
        if (!selectedTab||selectedTab==='') {
            selectedTab = 'homeTab';
        }

        this.state = {
            selectedTab: selectedTab
        }
        
    }

    componentDidMount() {
        this.loadAgentProfile()
    }

    loadAgentProfile = () => {
        DataFetcher.agentProfile({
            success: (resp) => {
            },
            logicError: () => {
                this.tryDelegateAccount()
            },
            sysError: () => {
                this.tryDelegateAccount()
            }
        })
    }

    tryDelegateAccount = () => {
        DataFetcher.delegateAccounts({
            success: (resp) => {
                if(resp.data&&resp.data.length) {
                    history.replace(`/delegate/home/${resp.data[0].id}`)
                } else {
                    history.replace("/about")
                }
            },
            logicError: () => {
                history.replace("/about")
            },
            sysError: () => {
                history.replace("/about")
            }
        })
    }

    render() {
        const { selectedTab } = this.state;
        StorageUtils.storeStringToSession(Constants.Storage.HOME_SELECTED_TAB, selectedTab);

        return (
            <div className="app-container">
                <TabBar unselectedTintColor="#8a8a8a" tintColor="#04bbc5" barTintColor="white">
                    <TabBar.Item 
                        title="代理" 
                        key="Home" 
                        icon={iconHome}
                        selectedIcon={iconHomeSelected}
                        selected={selectedTab === 'homeTab'}
                        onPress={() => {
                            this.setState({
                                selectedTab: 'homeTab'
                            });
                        }}
                    >
                        <HomeOfAgent tabName="homeTab"/>
                    </TabBar.Item>
                    <TabBar.Item
                        title="订单"
                        key="Order"
                        icon={iconOrder}
                        selectedIcon={iconOrderSelected}
                        selected={selectedTab === 'orderTab'}
                        onPress={() => {
                            this.setState({
                                selectedTab: 'orderTab'
                            });
                        }}
                    >  
                        <OrderOfAgent tabName="orderTab"/>
                    </TabBar.Item>
                    <TabBar.Item
                        title="我的"
                        key="Mine"
                        icon={iconMine}
                        selectedIcon={iconMineSelected}
                        selected={selectedTab === 'mineTab'}
                        onPress={() => {
                            this.setState({
                                selectedTab: 'mineTab'
                            });
                        }}
                    >  
                        <AgentMine tabName="mineTab"/>
                    </TabBar.Item>
                </TabBar>
            </div>
        )
    }
}

export default Agent;


// WEBPACK FOOTER //
// ./src/modules/Agent.js